import { BindingPath } from "../../../../Engine/Core/CoreTypes";

export enum InstanceNumberActionType {
    AddInstanceNumber = "ADD_INSTANCE_NUMBER",
    RemoveInstanceNumber = "REMOVE_INSTANCE_NUMBER",
}

export type InstanceNumberAction =
    | {
          type: InstanceNumberActionType.AddInstanceNumber;
          payload: {
              bindingPath: BindingPath;
              instanceNumber: number;
          };
      }
    | {
          type: InstanceNumberActionType.RemoveInstanceNumber;
          payload: {
              bindingPath: BindingPath;
          };
      };
